import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DreListarComponent } from './dre-listar/dre-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: DreListarComponent}
  ])],
  exports: [RouterModule]
})
export class DreRoutingModule { }
